module.exports = __webpack_public_path__ + "static/media/logo15.3977fd54.png";